<template>
  <div class="bracket-controls">
    <v-btn-group class="bracket-controls-group" density="compact" variant="text">
      <v-tooltip :text="fullscreen ? 'Exit fullscreen (F)' : 'Enter fullscreen (F)'" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="tip"
            :icon="fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"
            @click="$emit('toggle-fullscreen')"
            aria-label="Toggle fullscreen"
          />
        </template>
      </v-tooltip>
      <v-tooltip text="Zoom in (+)" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="tip"
            icon="mdi-magnify-plus"
            @click="$emit('zoom-in')"
            aria-label="Zoom in"
          />
        </template>
      </v-tooltip>
      <v-tooltip text="Zoom out (-)" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="tip"
            icon="mdi-magnify-minus"
            @click="$emit('zoom-out')"
            aria-label="Zoom out"
          />
        </template>
      </v-tooltip>
      <v-tooltip text="Reset zoom and pan" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="tip"
            icon="mdi-fit-to-page-outline"
            @click="$emit('reset-zoom')"
            aria-label="Reset zoom and pan"
          />
        </template>
      </v-tooltip>
      <v-tooltip :text="minimapCollapsed ? 'Show minimap' : 'Hide minimap'" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="tip"
            :icon="minimapCollapsed ? 'mdi-map-outline' : 'mdi-map-check'"
            @click="$emit('toggle-minimap')"
            aria-label="Toggle minimap"
          />
        </template>
      </v-tooltip>
    </v-btn-group>
  </div>
</template>

<script setup>
defineProps({
  fullscreen: {
    type: Boolean,
    required: true
  },
  minimapCollapsed: {
    type: Boolean,
    required: true
  }
})

defineEmits(['toggle-fullscreen', 'zoom-in', 'zoom-out', 'reset-zoom', 'toggle-minimap'])
</script>

<style scoped>
.bracket-controls {
  position: absolute;
  top: 80px;
  right: 16px;
  z-index: 1001;
  transition: top 0.3s ease;
}

.bracket-controls-group {
  background: rgb(var(--v-theme-surface));
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.bracket-controls-group :deep(.v-btn) {
  color: rgb(var(--v-theme-charcoal));
}
</style>
